module.exports = __webpack_public_path__ + "static/media/use5.da1dea31.jpeg";